<template>
  <div class="sidebar">
    <div class="list">
      <a href="#" class="item" :class="active == '#' ? 'active' : ''" @click="changeTabs('#')">首页</a>
      <a 
        :href="`#${item.id}`" 
        v-for="(item, index) in tabList" 
        :key="index"
        class="item"
        :class="active == item.id ? 'active' : ''"
        @click="changeTabs(item.id)"
      >{{item.name}}</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabList: [
        // { id: '#', name: '首页'},
        { id: 'dhjj', name: '大会简介'},
        { id: 'wqjb', name: '往届嘉宾'},
        { id: 'dhyc', name: '大会议程'},
        { id: 'zbfjj', name: '主办方简介'},
        { id: 'zzs', name: '赞助商'},
        { id: 'hzdw', name: '合作单位'},
        { id: 'lxwm', name: '联系我们'},
        { id: 'gzwm', name: '关注我们'},
        { id: 'wjhg', name: '往届回顾'}
      ],
      active: '#'
    }
  },
  methods: {
    changeTabs(e) {
      this.active = e
    }
  }
}
</script>
<style lang="less" scoped>
.sidebar {
  width: 83px;
  position: fixed;
  right: 0;
  // top: 457px;
  top: 20%;
  z-index: 999;
  .list {
    width: 100%;
    .item {
      display: block;
      width: 100%;
      height: 32px;
      background: rgba(6, 36, 123, 0.37);
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 32px;
      margin-bottom: 3px;
      text-align: right;
      box-sizing: border-box;
      padding-right: 10px;
    }
    .active {
      background: #06247B;
      color: #00FFFC;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sidebar.vue